/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const createClipsFromSubtitleSearchV1BodySchema = z.object({
  matches: z
    .array(
      z.object({
        collectionId: z.number().int().positive(),
        subtitleId: z.number().int().positive(),
        entryIndices: z.array(z.number().int().nonnegative()).min(1),
      }),
    )
    .min(1)
    .max(200),
});

export type ICreateClipsFromSubtitleSearchV1Request = z.infer<
  typeof createClipsFromSubtitleSearchV1BodySchema
>;
